
// @ts-nocheck
import { reactive, ref,inject,onMounted ,watch, nextTick, getCurrentInstance  } from 'vue'
import { useRoute,useRouter } from 'vue-router'
import {Toast} from 'vant'
import phoneEmail from '../../components/email-phone/index.vue'
import loginVue from '../../components/login/index.vue'
import {loginFn} from '../../hooks/index'
export default { 
  components:{
    phoneEmailVue:phoneEmail,
    loginVue
  },
  beforeRouteEnter(to, from, next){ 
          common.delStorage('loginBackBtnFlag')
          common.delStorage('redirect_url')
          console.log(from.name,'from.fullPathfrom.fullPath')
          if(!(from&&from.fullPath)) return false
          if(!['setting','policy'].includes(from.name))  common.setStorage('redirect_url', from.fullPath)
          if(from&&from.meta&&from.meta.requireAuth) {
            common.setStorage('loginBackBtnFlag', true)
          }
     next((vm)=>{   
     })
  },
 setup() {
    // 是否在传音APP内
    const isByteApp = sessionStorage.getItem('source') === 'byteApp'

    const internalInstance  = getCurrentInstance()
    const Vue3GoogleOauth = inject("Vue3GoogleOauth");

    const router = useRouter()
    const route = useRoute()
    const tabActive = ref(0);
    const password = ref('');
    const $get_facebook_appId = inject('$get_facebook_appId')
    const passwordVerify = ref(true);
    const isShowPassword = ref(false);
    const PrivacyChecked = ref(true);
    const fromDate = ref(null)
    const verifyLength = () => {
      return passwordVerify.value = password.value.length>=6? true : false
    }
    const isShowPWFn = () => {
      isShowPassword.value = !isShowPassword.value 
    }
    const watchPaswFn = () => {
      if(!password.value) {
        passwordVerify.value = true
      } else if(password.value.length >= 6) {
        passwordVerify.value = true
      }
    }
    const registerType = ref(true)
    const loading = ref(false)
       const $http = inject('$http')
       // email phone Type切换
    const registerTypeFn = () => {
      registerType.value = !registerType.value
      fromDate.value.verify.email = ''
      fromDate.value.verify.phone = ''
      password.value = ''

    }
      
    const submitFn = async () => {
    // console.log($http,'fromDate1')
      if(registerType.value&&(!fromDate.value.verify.email || fromDate.value.isEmailHint)){
          return Toast("Please input a valid email address.")
      }
      if(!registerType.value&&(!fromDate.value.verify.phone || fromDate.value.isPhoneHint)){
          return Toast("Please input valid phone number.")
      }
      if(!password.value){
          return Toast("Minimum 6 characters required.")
      }
      if(!fromDate.value.verify.code) {
          return Toast("Please enter the verification code.")
      }
      if(PrivacyChecked.value==false){
          return Toast("Please tick and accept the 'Terms and Conditions'")
      } 
        loading.value = true
        let params = reactive({
        country_code:"",
        phone:fromDate.value.verify.phone,
        captcha:fromDate.value.verify.code,
        email:fromDate.value.verify.email,
        password:password.value
      })
      // true 邮箱注册
      if(registerType.value == true){
          params.email =  fromDate.value.verify.email
          params.captcha =  fromDate.value.verify.code
      }else{
          params.country_code =  fromDate.value.country_code
          params.phone = fromDate.value.verify.phone
          params.captcha = fromDate.value.verify.code
      } 
      let ret = await $http.register(params)
      loading.value = false
      if(ret.code==200){
       loginFn(ret.data,$http,'')
      }else{
          Toast(ret.message)
      }
    }
    const goRegisterFn = (index ) => {
      tabActive.value = index
      passwordVerify.value = true
    }
     watch(tabActive, (state) => {
       nextTick(() => {
        fromDate.value.isEmailHint = false
        fromDate.value.isPhoneHint  = false
       })
      passwordVerify.value = true
    });
    watch(registerType, (state) => {
       nextTick(() => {
        fromDate.value.isEmailHint = false
        fromDate.value.isPhoneHint  = false
        fromDate.value.count = 0
       })
      passwordVerify.value = true
    });
         let info = reactive({})
 onMounted( async()=>{      
   if(route.query.type == 'register') tabActive.value = 1 
        if (route.query.info) info = getInfo();
           facebookInit()
        window.fbAsyncInit = function () { facebookInit() }           
      });
      let facebook_loading = ref(false)
    // facebook 
     const facebookInit =  () => {
            let id = 'facebook-jssdk';
            if (!document.getElementById(id)) {
                let js, fjs = document.getElementsByTagName('script')[0];
                js = document.createElement('script');
                js.id = id;
                js.src = "//connect.facebook.net/en_US/sdk.js";
                fjs.parentNode.insertBefore(js, fjs);
            }      
            if (typeof(FB) == 'undefined') return // eslint-disable-next-line
            FB.init({ appId:$get_facebook_appId(), cookie: true, xfbml: true, version: 'v3.2' })
            // FB.getLoginStatus(ret => { this.facebookStatus(ret, false) })
        }
        /**
         * FB 登陆命令
         */
        const facebookLogin =   () =>  {
            facebook_loading.value = true;
            if (typeof(FB) == 'undefined') return // eslint-disable-next-line
            FB.login(ret => { facebookStatus(ret) }, { scope: 'public_profile,email', return_scopes: true })            
            setTimeout(() => {
               facebook_loading.value = false;  
            }, 1000);
        }
        /**
         * Google auto2.0
         */
        const  googleLogin = async () => {
          let $gAuth = internalInstance?.appContext.config.globalProperties.$gAuth
          try {
            const googleUser = await $gAuth.signIn();
            if (!googleUser) return null
            let google_login_params = {
              googleIdToken: googleUser.getAuthResponse().id_token,
              source: '3',
              sl_source: '',
              third_firstname: '',
              third_lastname: '',
              third_avatar: '',
              third_email: googleUser.getBasicProfile().getEmail(),
              google_quick: 0
            }
            login(google_login_params).then(ret => {
                // if (ret.code == 402) return this.$router.replace('/register?info=facebook') // 还未注册
            })
          } catch (error) {
            //on fail do something
            console.log(error);
            return null;
          }
        }
        /**
         * FB 登陆流程
         */
         const facebookStatus =   (ret)   => {
            if (ret.status !== 'connected') return // eslint-disable-next-line
            FB.api('/me?fields=id,first_name,last_name,name,email,gender', ret => { 
                let gender = 0
                switch (ret.gender) {
                    case 'male': gender = 1; break
                    case 'female': gender = 2; break
                }

                info = {
                    type: 'FACEBOOK',
                    id: ret.id,
                    name: ret.name,
                    email: ret.email,
                    gender: gender,
                    avatar: 'https://graph.facebook.com/' + ret.id + '/picture?width=400',
                }
                localStorage.setItem('info', JSON.stringify(info)); 
                let params = {
                  facebookid: ret.id,
                  type: 1,
                  client: 'wap',
                  sl_source: '',
                  third_firstname: ret.first_name ? ret.first_name : '',
                  third_lastname: ret.last_name ? ret.last_name : '',
                  third_avatar: '',
                  third_email: ret.email,
                }                 
                login(params).then(ret => {
                    // if (ret.code == 402) return this.$router.replace('/register?info=facebook') // 还未注册
                })
            })            
        }
         /**
         * 登陆逻辑
         */
       const login =  async  (para,type) => {          
            let ret = await $http.login(para)
            if (ret.code == 200) {                
                if(!ret.data.email && !ret.data.phone){
                   loginFn(ret.data,$http, 'bind');
                 }else{
                   loginFn(ret.data,$http,'');
                 }
            }else if(ret.code == 402){
                if(type=='login'){
                    Toast(ret.message);
                }else{
                   router.push('/findPwd?type=register') // 还未注册
                }               
            }else{
                Toast(ret.message);
            }
            return ret
        }
        const goPriFn = function () {
                 router.push({
            name:'policy',
            params:{
              id:2126,
            }
          })
        }
        const goHomeFn = () => {
          if(common.getStorage('loginBackBtnFlag')) {
          router.push('/usercenter')
          } else {
          router.go(-1)
          }
        }
    return { isByteApp, Vue3GoogleOauth, googleLogin, tabActive,password,verifyLength,passwordVerify,isShowPassword,isShowPWFn,registerType,PrivacyChecked,submitFn,fromDate,loading,registerTypeFn,goRegisterFn,facebookLogin,goPriFn,goHomeFn,watchPaswFn,Toast };
  },
 
}
function getInfo () {
            let info = localStorage.getItem('info')
            if (!info) return
             JSON.parse(info);
            return JSON.parse(info)
        }
